import React from "react";
import { RxHamburgerMenu } from "react-icons/rx";
import { SlLocationPin } from "react-icons/sl";
import logo from "../assets/images/maskedLogo.svg";
import logoMain from "../assets/images/logo.svg";
import { RxCross1 } from "react-icons/rx";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { LuMail } from "react-icons/lu";
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { RiInstagramFill } from "react-icons/ri";
import { FaFacebook, FaLinkedin } from "react-icons/fa";

type NavType = {
  name: string;
  path: string;
};

const navigation: NavType[] = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "Services",
    path: "/services",
  },
  // {
  //   name: "Case Study",
  //   path: "/case-study",
  // },
  {
    name: "Blog",
    path: "/blogs",
  },
  {
    name: "About",
    path: "/about",
  },
  {
    name: "Contact",
    path: "/contact-us",
  },
];

const Nav = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <motion.div
        transition={{ duration: 0.6, delay: 0.5 }}
        className={`hidden sm:flex absolute w-[500px] z-50 overflow-hidden jost-regular rounded-r-2xl text-white justify-end px-4 transition-all duration-300 ${isOpen ? "top-[0px] left-0 h-screen !rounded-none !bg-primary" : "top-[10%] -left-[440px]"} flex h-[calc(90vh-4rem)] mb-20 bg-secondary max-w-[500px] rounded-r-2xl transition-all duration-300`}
      >
        <div className="w-full flex flex-col my-4 justify-between">
          <img src={logo} className="h-20" alt="maskedLogo" />
          <div className="flex flex-col gap-2">
            {navigation.map((item, index) => (
              <Link
                to={item.path}
                key={index}
                className="text-lg cursor-pointer hover:underline"
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </Link>
            ))}
          </div>
          <div className="flex flex-col gap-2 -mb-20">
            <div className="flex gap-4 items-center">
              <LuMail className="w-8 h-8" />
              <a href="mailto:laila.khan@psycheethos.com" className="text-lg">
                laila.khan@psycheethos.com
              </a>
            </div>

            <div className="flex gap-4 items-center">
              <MdOutlinePhoneInTalk className="w-8 h-8" />
              <a href="tel:+447796958622" className="text-lg">
                +447796958622
              </a>
            </div>

            <div className="flex gap-4 items-center">
              <SlLocationPin className="w-8 h-8" />
              <a href="" className="text-lg max-w-[300px]">
                <p>71-75 Shelton Street Covent Garden, London WC2 9JQ U.K.</p>
              </a>
            </div>
          </div>

          <div className="flex gap-4 items-center py-3">
            <div
              onClick={() =>
                window.open("https://www.instagram.com/nightstarstorytelling/")
              }
              className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center"
            >
              <RiInstagramFill className="text-2xl text-white" />
            </div>
            <div className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center">
              <FaLinkedin className="text-2xl text-white" />
            </div>
            <div className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center">
              <FaFacebook className="text-2xl text-white" />
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center">
          {isOpen ? (
            <RxCross1
              onClick={() => setIsOpen(!isOpen)}
              className="text-5xl cursor-pointer"
            />
          ) : (
            <RxHamburgerMenu
              onClick={() => setIsOpen(!isOpen)}
              className="text-3xl cursor-pointer"
            />
          )}
        </div>
      </motion.div>
      <div
        className={`absolute flex flex-col justify-between w-full transition-all jost-regular bg-black bg-opacity-60 duration-300 ${isOpen ? "h-[500px] bg-primary !bg-opacity-100" : "h-16"} flex sm:hidden z-50 top-0 text-white`}
      >
        <div className="w-full flex justify-between">
          <div className="py-2 px-4">
            <img
              src={isOpen ? logo : logoMain}
              className="h-12"
              alt="maskedLogo"
            />
          </div>
          <div
            className={`w-16 h-16 flex justify-center items-center transition-all duration-300 ${isOpen ? "bg-primary" : "bg-secondary"}`}
          >
            {isOpen ? (
              <RxCross1
                onClick={() => setIsOpen(!isOpen)}
                className="text-3xl cursor-pointer"
              />
            ) : (
              <RxHamburgerMenu
                onClick={() => setIsOpen(!isOpen)}
                className="text-3xl cursor-pointer"
              />
            )}
          </div>
        </div>

        <div className={`${isOpen ? "flex" : "hidden"} flex-col gap-2 px-8`}>
          {navigation.map((item, index) => (
            <Link
              to={item.path}
              key={index}
              className="text-lg cursor-pointer hover:underline"
              onClick={() => setIsOpen(false)}
            >
              {item.name}
            </Link>
          ))}
        </div>
        <div
          className={`${isOpen ? "flex" : "hidden"} gap-4 items-center pb-4 px-8`}
        >
          <div
            onClick={() =>
              window.open("https://www.instagram.com/nightstarstorytelling/")
            }
            className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center"
          >
            <RiInstagramFill className="text-2xl text-white" />
          </div>
          <div className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center">
            <FaLinkedin className="text-2xl text-white" />
          </div>
          <div className="p-1 cursor-pointer border rounded-full w-10 h-10 hover:-translate-y-1 transition-all duration-300 flex justify-center items-center">
            <FaFacebook className="text-2xl text-white" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Nav;
